import type { RouteMeta } from 'vue-router'
import type { Locale } from './locale'

export enum PageType {
  Pharmacy = 'pharmacy-page',
  Checkout = 'checkout-page',
  Cart = 'cart-page',
  Login = 'login-page',
  Logout = 'logout-page',
  Product = 'product-page',
  Search = 'search-page',
  PrescriptionUpload = 'prescription-upload-page',
  Faq = 'faq',
  WhatsAppPrivacyPage = 'whatsapp-datenschutz',
  WhatsAppCreateCartPage = 'whatsapp-create-cart',
}

export enum UttPageTypeEnum {
  cart = 'cart',
  product = 'product',
  category = 'category',
  home = 'home',
}

export type ExpandedPageMeta = RouteMeta & {
  type?: PageType
  lang?: Locale
  onlyPharmacyId?: boolean
  pharmacyRoot?: boolean
  isHomepage?: boolean
  fullPharmacySlug?: boolean
  redirectPharmacy?: string[]
  uttType?: string
}
